/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PackageSimple
 */
export interface PackageSimple {
  /**
   *
   * @type {number}
   * @memberof PackageSimple
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof PackageSimple
   */
  code: string;
  /**
   *
   * @type {Array<string>}
   * @memberof PackageSimple
   */
  channels: Array<string>;
  /**
   *
   * @type {string}
   * @memberof PackageSimple
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof PackageSimple
   */
  targetGroupId: string;
}

export function PackageSimpleFromJSON(json: any): PackageSimple {
  return PackageSimpleFromJSONTyped(json, false);
}

export function PackageSimpleFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PackageSimple {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    code: json["code"],
    channels: json["channels"],
    name: json["name"],
    targetGroupId: json["targetGroupId"],
  };
}

export function PackageSimpleToJSON(value?: PackageSimple | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    code: value.code,
    channels: value.channels,
    name: value.name,
    targetGroupId: value.targetGroupId,
  };
}
